export default "__VITE_ASSET__f865da3e__"